var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Menu, Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useSearchableMenu } from 'shared/domains/common-ui/SearchableMenu';
export function AddItem(props) {
    const { onAddNewParty } = props;
    const { searchString, resetSearch, searching, items } = useSearchableMenu();
    const handleAdd = () => __awaiter(this, void 0, void 0, function* () {
        onAddNewParty({ id: searchString });
        resetSearch();
    });
    const exactMatch = items.find((item) => item.id.toLowerCase().trim() === searchString.toLowerCase().trim());
    if (!searchString || !searching || exactMatch) {
        return null;
    }
    return (<Menu.Item onClick={handleAdd}>
      <Box alignItems="center" gap="sm">
        <Box alignItems="center" gap="md">
          <Falcon icon="plus"/>
          <Typography $appearance="300" $fontSize="small" $lineHeight="neutralized">
            {t({ comment: 'Bulk action: Metadata - Parties menu - Create new party', message: 'Create new:' })}
          </Typography>
        </Box>
        <Typography $appearance="100" $fontSize="small" $fontStyle="italic" $lineHeight="neutralized">
          {searchString}
        </Typography>
      </Box>
    </Menu.Item>);
}
